// Ready-made starter templates for newsletters, announcements, and documents.
export const NEWSLETTER_TEMPLATES = [
  {
    id: "event_invite",
    label: "Event Invite",
    subject: "You're Invited — [Event Name]",
    message:
      "## You're Invited\nBrothers, join us for **[Event Name]** on **[Date]** at **[Time]**, [Location].\n\nCome expecting encouragement, brotherhood, and the Word. Bring a friend.\n\n[RSVP / Details](https://ihimm.org/events)",
  },
  {
    id: "monthly_update",
    label: "Monthly Update",
    subject: "This Month at In His Image",
    message:
      "## This Month at In His Image\nHere's what God has been doing in our community.\n\n**Highlights**\n- [Highlight one]\n- [Highlight two]\n\n**Coming Up**\n- [Upcoming event or gathering]\n\nThank you for walking this road with us. [See more](https://ihimm.org)",
  },
  {
    id: "call_to_prayer",
    label: "Call to Prayer",
    subject: "A Call to Prayer",
    message:
      "## A Call to Prayer\nFamily, we're setting aside time to seek the Lord together.\n\n**How to join:** [Details]\n\nIf you have a request, share it on our [Prayer Wall](https://ihimm.org/prayers). Iron sharpens iron — let's stand together.",
  },
  {
    id: "giving_appeal",
    label: "Giving Appeal",
    subject: "Partner With Us",
    message:
      "## Partner With Us\nYour generosity fuels this ministry to men. Every gift helps us disciple, gather, and serve.\n\nWould you prayerfully consider partnering with us this season?\n\n[Give Today](https://ihimm.org/supporter)",
  },
  {
    id: "welcome",
    label: "Welcome",
    subject: "Welcome to the Family",
    message:
      "## Welcome to the Family\nWe're so glad you're here. You were made in His image — a son, called, not condemned.\n\nHere are a few ways to get started:\n- Join the [Community Feed](https://ihimm.org/feed)\n- Explore [Devotionals](https://ihimm.org/devotionals)\n- Attend an upcoming [Event](https://ihimm.org/events)",
  },
];
